import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
// スタイルのインポート（ビルドツールの設定に合わせて適宜調整してください）
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * SWELLのギャラリー構造をSwiperに変換して初期化する
 */
export const initEventSlider = () => {
	console.log("--- Swiper Init Start ---");
	// 1. コンテナとなる要素を取得
	const sliderContainer = document.querySelector(".schoollife-slider .swell-block-fullWide__inner");
	console.log("Target Container:", sliderContainer);
	if (!sliderContainer) return;

	// 2. Swiperに必要なクラスをJSで強制付与
	const wrapper = sliderContainer.querySelector(".wp-block-gallery");
	const slides = sliderContainer.querySelectorAll(".wp-block-image");

	if (!wrapper || slides.length === 0) return;

	sliderContainer.classList.add("swiper");
	wrapper.classList.add("swiper-wrapper");
	slides.forEach((slide) => {
		slide.classList.add("swiper-slide");
	});

	// 3. Swiperの初期化
	const swiper = new Swiper(sliderContainer, {
		modules: [Autoplay],
		slidesPerView: 1.5, // 横から少しはみ出す設定
		centeredSlides: true, // 中央寄せ
		spaceBetween: 20, // 隙間
		loop: true, // ループ
		speed: 1000,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		// 必要に応じてページネーションなどを追加
		// pagination: {
		// 	el: ".swiper-pagination",
		// 	clickable: true,
		// },
		// レスポンシブ設定
		breakpoints: {
			768: {
				slidesPerView: 3.5,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 5.5,
				spaceBetween: 30,
			},
		},
	});

	return swiper;
};
